export default __webpack_public_path__ + "static/steve-beimel-e581394408c4f1f3ad488bba08e4a5df.jpg";